import validator from 'validator';

export const isEmpty = (value) => {
  if (validator.isEmpty(value)) return false;
  return true;
};

export const isEmail = (value) => {
  if (!validator.isEmail(value)) return false;
  return true;
};

export const required = (value) => value.trim() !== '';

export const length = (config) => (value) => {
  let isValid = true;
  if (config.min) {
    isValid = isValid && value.trim().length >= config.min;
  }
  if (config.max) {
    isValid = isValid && value.trim().length <= config.max;
  }
  return isValid;
};

export const number = (value) => /^[0-9]+$/.test(value);

export const alphanumeric = (value) => /^[a-zA-Z0-9\s]+$/.test(value);

export const alpha = (value) => /^[a-zA-Z\s]+$/.test(value);

export const email = (value) =>
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(
    value
  );

export const ip = (value) =>
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
    value
  );

export const url = (value) => {
  try {
    new URL(value);
    return true;
  } catch (_) {
    return false;
  }
};

export const countWords = (config) => (value) => {
  let isValid = true;
  value = value.replace(/(^\s*)|(\s*$)/gi, '');
  value = value.replace(/[ ]{2,}/gi, ' ');
  value = value.replace(/\n /, '\n');

  if (config.min) {
    isValid = isValid && value.split(' ').length >= config.min;
  }
  if (config.max) {
    isValid = isValid && value.split(' ').length <= config.max;
  }

  return isValid;
};
